module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_sola-668f84f4b0dca298979e2f803f03e18f.svg";